import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Label = React.forwardRef(({ className = '', ...props }, ref) => {
    return (_jsx("label", { ref: ref, className: `text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 ${className}`, ...props }));
});
Label.displayName = 'Label';
